import { INDIVIDUAL } from '@Utils/constants';
import isEmpty from 'lodash/isEmpty';
import { PAYTM_UPI_ID_ERROR_MESSAGE } from '../../screens/beneficiary-info/constant';

export const beneSchemaValidation = (values, bene_schema) => {
  const errors = {};
  const checkForINR =
    values.bank_account_country === 'IN' &&
    values.currency_code === 'INR' &&
    values.account_type === INDIVIDUAL;
  const checkForPaytmUPI =
    values.proxy_type === 'VPA' && values.proxy_value?.toLowerCase().includes('@paytm');

  Object.keys(bene_schema).forEach((object) => {
    Object.keys(bene_schema[object]).forEach((field) => {
      if (
        bene_schema[object][field]?.validation?.required &&
        isEmpty(values[bene_schema[object][field]?.render?.['value_field_name']]?.toString())
      ) {
        errors[bene_schema[object][field].render['value_field_name']] = 'Required';
      } else if (bene_schema[object][field]?.validation?.pattern) {
        const globalRegex = new RegExp(bene_schema[object][field].validation.pattern, 'g');
        const regexValidation =
          !globalRegex.test(values[bene_schema[object][field].render['value_field_name']] || '') &&
          bene_schema[object][field].validation.error_message;
        if (regexValidation) {
          errors[bene_schema[object][field].render['value_field_name']] = regexValidation;
        }
      }
    });
  });
  if (checkForINR && checkForPaytmUPI) {
    errors[bene_schema['payout_details']['proxy_value'].render['value_field_name']] =
      PAYTM_UPI_ID_ERROR_MESSAGE;
  }

  return errors;
};
